import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const ReportIcon = (props) => {
  return (

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 2 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.88 2.66536H12.6667C13.4 2.66536 14 3.26536 14 3.9987V13.332C14 14.0654 13.4 14.6654 12.6667 14.6654H3.33333C3.24 14.6654 3.15333 14.6587 3.06667 14.6454C2.80667 14.592 2.57333 14.4587 2.39333 14.2787C2.27333 14.152 2.17333 14.012 2.10667 13.852C2.04 13.692 2 13.512 2 13.332V3.9987C2 3.81203 2.04 3.6387 2.10667 3.48536C2.17333 3.32536 2.27333 3.1787 2.39333 3.0587C2.57333 2.8787 2.80667 2.74536 3.06667 2.69203C3.15333 2.67203 3.24 2.66536 3.33333 2.66536H6.12C6.4 1.89203 7.13333 1.33203 8 1.33203C8.86667 1.33203 9.6 1.89203 9.88 2.66536ZM4.66667 6.66536V5.33203H11.3333V6.66536H4.66667ZM11.3333 9.33203V7.9987H4.66667V9.33203H11.3333ZM9.33333 10.6654H4.66667V11.9987H9.33333V10.6654ZM8 2.4987C8.27333 2.4987 8.5 2.72536 8.5 2.9987C8.5 3.27203 8.27333 3.4987 8 3.4987C7.72667 3.4987 7.5 3.27203 7.5 2.9987C7.5 2.72536 7.72667 2.4987 8 2.4987ZM3.33333 13.332H12.6667V3.9987H3.33333V13.332Z"
        // fill="#FAFAFA"
        fill={props.color}
        />
    </svg>
  );
};

export default ReportIcon;
